// extracted by mini-css-extract-plugin
export default {"menuBlock":"xH-z","title":"yH-z","nav":"zH-z","flexCell":"AH-z","facetLink":"BH-z"};